import m from "../../geodata/es2015/netherlandsLow";
window.am4geodata_netherlandsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/netherlandsLow.js
// module id = null
// module chunks = 